import React from 'react'

const CardReport = (props) => {
    return (
        <div className="col-xl-2 w-20p px-2">
            <div className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100 ${props.className}`}>
                {/* <div className="card-header pt-5 mb-3">
                    <div className="d-flex flex-center rounded-circle h-80px w-80px" style={{border : '1px dashed rgba(255, 255, 255, 0.4)'}}>
                        <i className="ki-duotone ki-car-2 text-white fs-4x lh-0">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                            <span className="path4"></span>
                            <span className="path5"></span>
                            <span className="path6"></span>
                        </i>
                    </div>
                </div> */}
                <div className="card-body d-flex align-items-center mb-3 py-3">
                    <div className={`d-flex ${props.title == 0 ? 'align-items-center' : ''}`}>
                        <span className={`${props.title_color} fw-bold inactive-vehicle-count`}>{props.title}</span>
                    </div>
                </div>
                <div className="card-footer py-3" style={{borderTop: '1px solid rgba(255, 255, 255, 0.3)', background:'rgba(0, 0, 0, 0.15)'}}>
                    <div className="fw-bold text-dark py-2">
                        <span className="fs-2 d-block">{props.sub_title}</span>
                        <span className="opacity-50">Now delivering parcels</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardReport;